<!--header-->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Public Transport
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home"/>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--West and East Tabulator-->
  <ion-segment fill="outline" color="medium" [(ngModel)]='station'>
    <ion-segment-button value='west'>
      West
    </ion-segment-button>
    <ion-segment-button value='east'>
      East
    </ion-segment-button>
  </ion-segment>
  <div [ngSwitch]="station">
    <ion-card color="light">
      <!--East Busstation-->
      <div class='embed-container' *ngSwitchCase="'east'">
        <iframe name="Bus schedule of the east station"
                src='https://www.oevplus.ch/monitor/?viewType=singleView&layout=1&showClock=false&showPerron=false&stationGroup1Title=Villigen%2C%20PSI%20Ost&station_1_id=85%3A3599&station_1_name=Villigen%2C%20PSI%20Ost&station_1_quantity=5&station_1_group=1'
                style='border:0'></iframe>
      </div>
      <!--West Busstation-->
      <div class='embed-container' *ngSwitchCase="'west'">
        <iframe name="Bus schedule of the west station"
                src="https://www.oevplus.ch/monitor/?viewType=singleView&layout=1&showClock=false&showPerron=false&stationGroup1Title=Villigen%2C%20PSI%20West&station_1_id=85%3A3592&station_1_name=Villigen%2C%20PSI%20West&station_1_quantity=5&station_1_group=1"
                style='border:0'></iframe>
      </div>
    </ion-card>
  </div>
  <!--Links to the SBB Mobile and Website-->
  <ion-card color="danger">
    <ion-card-header>
      <ion-card-subtitle>How to get to PSI?</ion-card-subtitle>
      <ion-card-title>SBB Mobile</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <!--Link to SBB Website-->
      <a title="Link to the SBB website" href="https://www.sbb.ch/" target="_blank" rel="noopener noreferrer">
        <ion-button shape="round" color="light" fill="outline">
          <ion-icon slot="start" name="train"></ion-icon>
          Visit the Website
        </ion-button>
      </a><br>
      <!--Link to App Store-->
      <a title="Link to the SBB App on Itunes" href="https://itunes.apple.com/app/sbb-mobile/id294855237"
         target="_blank" rel="noopener noreferrer">
        <ion-button shape="round" color="dark">
          <ion-icon slot="start" name="logo-apple"></ion-icon>
          Download on the App Store
        </ion-button>
      </a><br>
      <!--Link to Google Play-->
      <a title="Link to the SBB App on Google Play"
         href="https://play.google.com/store/apps/details?id=ch.sbb.mobile.android.b2c&feature=search_result&hl=en"
         target="_blank" rel="noopener noreferrer">
        <ion-button shape="round" color="dark">
          <ion-icon slot="start" name="logo-android"></ion-icon>
          Get it on Google Play
        </ion-button>
      </a>
    </ion-card-content>
  </ion-card>
</ion-content>
